import { compareDates } from "./dates";
import { isSystemRole, isTerminal } from "./statuses";
import type { NodeLike, PlainDate } from "./types";

/**
 * Критерий пустоты (MVP — простой): нет title, нет body, нет детей.
 * Пустая нода удаляется тихо, мимо архива — это «начал писать не то»
 * (spec-tasks Область 9).
 */
export function isEmpty(node: Pick<NodeLike, "title" | "body">, childCount: number): boolean {
	return node.title.trim() === "" && (node.body === null || node.body.trim() === "") && childCount === 0;
}

/**
 * Просрочка: дата в прошлом + статус НЕ терминальный + не архив (engineering §8.2).
 *
 * Отложенное (`paused`/`someday`) с невыключенной датой сюда ПОПАДАЕТ: дата, которую
 * не сняли, остаётся обязательством. Хочешь тишины — снимай дату, а не статус.
 */
export function isOverdue(node: Pick<NodeLike, "scheduledDate" | "status" | "archivedAt">, today: PlainDate): boolean {
	if (node.scheduledDate === null || node.archivedAt !== null) {
		return false;
	}
	if (isTerminal(node.status)) {
		return false;
	}
	return compareDates(node.scheduledDate, today) < 0;
}

export function isArchived(node: Pick<NodeLike, "archivedAt">): boolean {
	return node.archivedAt !== null;
}

/** Технические роли не показываются в пользовательских списках (панель «срок», поиск). */
export function isUserVisible(node: Pick<NodeLike, "role">): boolean {
	return !isSystemRole(node.role);
}
